import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store, ExternalLink } from "lucide-react";
import api from "../../lib/api";
import { Card, Badge, Spinner, EmptyState } from "../../lib/ui";
import { fmtRp } from "../../lib/constants";

export default function SuppliersTab() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [supRes, anaRes] = await Promise.all([
          api.get("/suppliers"),
          api.get("/purchasing/suppliers/analytics").catch(() => ({ data: { rows: [] } })),
        ]);
        const suppliers = Array.isArray(supRes.data) ? supRes.data : supRes.data.rows || [];
        const ana = {};
        (anaRes.data.rows || []).forEach((a) => { ana[a.supplier_id] = a; });
        setRows(suppliers.map((s) => ({ ...s, ...(ana[s.id] || {}) })));
      } catch { setRows([]); }
    })();
  }, []);

  return (
    <div data-testid="sc-suppliers">
      <div className="mb-3 flex items-center justify-between gap-2">
        <p className="text-sm text-ink-soft">Daftar supplier beserta total belanja & pembelian terakhir.</p>
        <Link to="/master-data?tab=Suppliers" className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline" data-testid="sc-suppliers-manage">
          Kelola Supplier <ExternalLink size={14} />
        </Link>
      </div>
      <Card>
        {!rows ? <div className="flex h-32 items-center justify-center"><Spinner className="h-7 w-7" /></div>
          : rows.length === 0 ? <EmptyState image={null} title="Belum ada supplier" subtitle="Tambahkan supplier melalui Master Data." />
          : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="sc-suppliers-table">
                <thead className="border-b border-line text-left text-xs uppercase tracking-wide text-ink-mute">
                  <tr>
                    <th className="py-2 pr-3">Supplier</th>
                    <th className="py-2 pr-3">Kontak</th>
                    <th className="py-2 pr-3">Kategori</th>
                    <th className="py-2 pr-3 text-center">Jumlah Pembelian</th>
                    <th className="py-2 pr-3 text-right">Total Belanja</th>
                    <th className="py-2 pr-3">Pembelian Terakhir</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-line">
                  {rows.map((s) => (
                    <tr key={s.id} data-testid={`sc-supplier-row-${s.id}`}>
                      <td className="py-2.5 pr-3 font-semibold text-ink">{s.name}</td>
                      <td className="py-2.5 pr-3 text-ink-soft">{s.contact || s.phone || "—"}</td>
                      <td className="py-2.5 pr-3">{s.category ? <Badge tone="mute">{s.category}</Badge> : <span className="text-ink-mute">—</span>}</td>
                      <td className="py-2.5 pr-3 text-center text-ink-soft">{s.purchase_count || 0}</td>
                      <td className="py-2.5 pr-3 text-right font-semibold text-ink">{fmtRp(s.total_spend || 0)}</td>
                      <td className="py-2.5 pr-3 text-xs text-ink-soft">{s.last_purchase || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </Card>
    </div>
  );
}
